import Logger from "js-logger";

export default function feldUtils(): any {
  function istInt(wert: any) {
    return /^(\d+)$/.test(wert);
  }

  function stringZuInt(wert: string) {
    if (istInt(wert)) {
      const geparst = parseInt(wert, 10);
      if (!isNaN(geparst)) {
        return geparst;
      }
    }
    return 0;
  }

  function sucheGewaehltenRadiowert(feldName: string) {
    let wert = "";
    const elem: any = document.querySelector("input[name='" + feldName + "']:checked");
    if (elem) {
      wert = elem.value.trim();
    }
    Logger.trace("sucheGewaehltenRadiowert", "feldName: " + feldName, "wert: " + wert);
    return wert;
  }

  return {
    istInt,
    stringZuInt,
    sucheGewaehltenRadiowert,
  };
}
